import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Coaching from "./pages/Coaching";
import Outplacement from "./pages/Outplacement";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import Team from "./pages/Team";
import Resources from "./pages/Resources";
import RaterEvaluation from "./pages/RaterEvaluation";
import AdminLogin from "./pages/AdminLogin";
import Legal from "./pages/Legal";

import "./App.css";

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/l-equipe" element={<Team />} />
            <Route path="/ressources" element={<Resources />} />
            <Route path="/evaluation/:token" element={<RaterEvaluation />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/outplacement" element={<Outplacement />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/rgpd" element={<Legal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/acces-admin" element={<AdminLogin />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reinitialiser/:token" element={<ResetPassword />} />
            <Route path="/changer-mot-de-passe" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/*" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
